import { TComputedPropMapper } from '../../types/computed-props-mapper';
import { getOfferName } from './title/getOfferName';
import { isDealRentCianAgency } from './isDealRentCianAgency';
import { isTop } from './isTop';
import { isPremium } from './isPremium';

export const title: TComputedPropMapper<string> = (props, ctx) => {
  if ((isTop(props, ctx) || isPremium(props, ctx)) && !!props.offer.title) {
    return isDealRentCianAgency(props, ctx) ? 'Прямая аренда от Циан' : props.offer.title;
  }

  return getOfferName(props.offer);
};
